import React, { FC, useEffect } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useBmsPurchasePoDetailsModel } from "../bmsBillPurchasePoModel";
import { RouterParamType } from "@/model/navModel";
import { IDetailList } from "../bmsBillPurchasePoType";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookList } = useBmsPurchasePoDetailsModel();
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 80,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            fixed: "left",
            // render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text} {record.icon === 1 && <span style={{ background: "orange", color: "white" }}>多</span>} </p></Tooltip>,
        }, {
            title: '采购数量',
            width: 120,
            dataIndex: 'num',
        }, {
            title: '采购单价',
            width: 120,
            dataIndex: 'price',
        }, {
            title: '采购金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '到货数量',
            width: 120,
            dataIndex: 'confirmNum',

        }, {
            title: '仓库',
            width: 160,
            dataIndex: 'warehouseCode'
        }, {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }
    ];

    return (
        <YhBox title={"配件信息"} style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={columns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}